/**
 * Layout Store
 *
 * Cross-cutting layout UI state that isn't owned by any single page,
 * e.g. features that need to force-collapse the main sidebar to free up space.
 *
 * @module store/layout/layoutStore
 */

import { create } from 'zustand';

export const useLayoutStore = create((set) => ({
  // State
  forceSidebarCollapsed: false,

  // Actions
  setForceSidebarCollapsed: (collapsed) => set({ forceSidebarCollapsed: collapsed })
}));
